import { v4 as uuidv4 } from 'uuid';

export const ANONYMOUS_USER_ID_KEY = 'anonymous-user-id';

/**
 * The browser's anonymous id, created and stored on first use. Page views and pitch views share it, and it is kept
 * after login, so the anonymous visits before a signup can be tied to the user that signed up in the same browser.
 */
export function getOrCreateAnonymousId(): UUID {
  try {
    const stored = window.localStorage.getItem(ANONYMOUS_USER_ID_KEY);
    if (stored) return JSON.parse(stored) as UUID;
  } catch (e) {
    // Fall through and create a new id
  }
  const id = uuidv4() as UUID;
  try {
    window.localStorage.setItem(ANONYMOUS_USER_ID_KEY, JSON.stringify(id));
  } catch (e) {
    // Storage blocked: the id lives for this page load only
  }
  return id;
}
